import { useEffect } from "react";
import { persistReferralCode } from "../services/referral";

const useReferralCode = () => {
  useEffect(() => {
    persistReferralCode(window.location.search);
  }, []);
};

export default useReferralCode;
